import { render, staticRenderFns } from "./ResearchOutputClaim.vue?vue&type=template&id=78c7fd67&scoped=true&"
import script from "./ResearchOutputClaim.vue?vue&type=script&lang=js&"
export * from "./ResearchOutputClaim.vue?vue&type=script&lang=js&"
import style0 from "./ResearchOutputClaim.vue?vue&type=style&index=0&id=78c7fd67&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c7fd67",
  null
  
)

export default component.exports